import { Helmet } from "react-helmet";

interface SchemaMarkupProps {
  schema: object;
}

const SchemaMarkup = ({ schema }: SchemaMarkupProps) => {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default SchemaMarkup;
